/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { useState, useRef, useCallback } from "react";
import { Box, ListItemButton, ListItemText, Typography } from '@mui/material';

import { useStyles } from "./styles";
import { TITLES } from "./constants";
import Loader from "../../shared/Loader";

interface ICustomSearchListProps {
  list: any;
  pagination: any;
  onSelectItem: Function;
  goToTheNextPage?: Function
  selectedItem: any
  onMouseDown?: any;
  maxHeight?: number;
}

const CustomSearchList = (props: ICustomSearchListProps) => {
  const { list, onSelectItem, goToTheNextPage, pagination, selectedItem, onMouseDown, maxHeight } = props;

  const { classes } = useStyles();
  const observerPanel: any = useRef();
  const [loading, setLoading] = useState(false);

  const lastElementRefPanel = useCallback((node: HTMLDivElement) => {
    if (observerPanel.current) observerPanel.current.disconnect();
    observerPanel.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setLoading(true);
        if (pagination.totalCount > list.length) {
          goToTheNextPage && goToTheNextPage(pagination.pageNumber + 1);
        } else {
          setLoading(false);
        }
      }
    });
    if (node) observerPanel.current.observe(node);
  }, [list]);

  const onClickSelectItem = (item: any) => {
    onSelectItem(item);
  };

  return (
    <div className={classes.searchList} onMouseDown={onMouseDown}>
      <Box maxHeight={maxHeight}>
        {list?.length ? (
          list.map((item: any, index: number) => {
            return (
              <ListItemButton
                key={index}
                onClick={() => onClickSelectItem(item)}
                data-testid={`panel-dimension-${index}`}
                className={classes.listItem}
                selected={item.id === selectedItem.id}
              >
                {list.length === index + 1 ? (
                  <ListItemText ref={lastElementRefPanel} primary={item.displayName} />
                ) : (
                  <ListItemText primary={item.displayName} />
                )}
              </ListItemButton>
            );
          })
        ) : (
          <Typography className={classes.noItem}>{TITLES.NO_ITEMS_FOUND}</Typography>
        )}
        {loading && (
          <Box alignContent={"center"}>
            <Loader showLoader={true} isCenter />
          </Box>
        )}
      </Box>
    </div>
  );
};

export default CustomSearchList;
